import React, { useMemo, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { navigate, useBasePath } from "raviger";

// Actions
import { changeNavigation } from "../../store/actions/navigation";

// Components
// import Header from "../../components/Header";
import ProgressBone from "../../components/ProgressBone";
import DesktopPage from "../../components/DesktopPage";
import Floor from "../../components/Floor/Floor";

// App HOC
const SinglePage = (props) => {
	const basepath = useBasePath();
	const dispatch = useDispatch();

	const currentQuestionId /*: string */ = useSelector(
		(state) => state.navigation.currentQuestion,
	);
	const surveyStep /*: number */ = useSelector(
		(state) => state.navigation.surveyStep,
	);

	const surveyQuestions = useSelector((state) => state.questions.questions);

	const pages = useMemo(() => {
		return surveyQuestions.reduce((pagesArr, question) => {
			const lastPage = pagesArr[pagesArr.length - 1];
			if (
				lastPage &&
				String(lastPage.desktopPage) ===
					String(question.desktop_page_no)
			) {
				lastPage.questions.push(question);
			} else {
				pagesArr.push({
					desktopPage: question.desktop_page_no,
					questions: [question],
				});
			}
			return pagesArr;
		}, []);
	}, [surveyQuestions]);

	const currentPageIndex = useMemo(() => {
		const currentQuestionPage = pages.findIndex((page) => {
			const questionFoundInPage = page.questions.findIndex((question) => {
				return String(question.id) === String(currentQuestionId);
			});
			if (questionFoundInPage >= 0) return true;
			else return false;
		});
		return currentQuestionPage;
	}, [currentQuestionId, pages]);

	const pageData = useMemo(() => {
		if (currentPageIndex < pages.length) {
			return pages[currentPageIndex];
		} else return null;
	}, [pages, currentPageIndex]);

	useEffect(() => {
		// to update the url when the page changes
		if (!pageData) {
			navigate(basepath + "/finish");
		} else {
			const urlQuestionId = pageData.questions[0].id;
			navigate(basepath + "/questions/" + urlQuestionId);
		}
	}, [pageData, basepath]);

	const handlePrevClick = useCallback(() => {
		if (currentPageIndex === 0) return;
		else {
			const prevPageIndex = currentPageIndex - 1;
			const prevQuestion = pages[prevPageIndex].questions[0];
			const prevQuestionId = prevQuestion.id;
			const prevSurveyStep = prevQuestion.survey_step;
			dispatch(
				changeNavigation({
					currentQuestion: String(prevQuestionId),
					surveyStep: prevSurveyStep,
				}),
			);
		}
	}, [currentPageIndex, dispatch, pages]);

	const handleNextClick = useCallback(() => {
		if (currentPageIndex === pages.length - 1)
			navigate(basepath + "/finish");
		else {
			const nextPageIndex = currentPageIndex + 1;
			const nextQuestion = pages[nextPageIndex].questions[0];
			const nextQuestionId = nextQuestion.id;
			const nextSurveyStep = nextQuestion.survey_step;
			dispatch(
				changeNavigation({
					currentQuestion: String(nextQuestionId),
					surveyStep: nextSurveyStep,
				}),
			);
		}
	}, [currentPageIndex, dispatch, basepath, pages]);

	return (
		<div
			className={"desktop desktop-container-" + currentQuestionId}
			style={{ minHeight: "100vh", height: "100%" }}
		>
			<ProgressBone step={surveyStep} />
			<div className={"questionaire question-" + currentQuestionId}>
				{/* <Header /> */}

				{pageData && (
					<DesktopPage
						pageData={pageData}
						handleBackButton={handlePrevClick}
						handleNextButton={handleNextClick}
					/>
				)}
				<Floor id={surveyStep} />
			</div>
		</div>
	);
};

export default SinglePage;
